import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { HIDE_SIDE_MENU_CONVERSATION } from "../../../../redux/action/menu/side/sideType";
import { useDispatch } from "react-redux";

const LogoSide = () => {
  const dispatch = useDispatch();

  const hideMenu = () => {
    dispatch({
      type: HIDE_SIDE_MENU_CONVERSATION,
    });
  };

  return (
    <div className="flex items-center justify-between mb-8">
      <Link to="/">
        <img
          className="w-9"
          src={`${process.env.PUBLIC_URL}/assets/images/logo/logo.png`}
          alt="موکلین وکیل‌سان"
        />
      </Link>
      <button onClick={hideMenu}>
        <ReactSVG
          className="w-5"
          src={`${process.env.PUBLIC_URL}/assets/images/icons/times.svg`}
        />
      </button>
    </div>
  );
};

export default LogoSide;
